import { createContext, FC, ReactNode, useContext, useState } from 'react';

interface DeliveryPanelContextType {
	isDeliveryPanelOpen: boolean;
	openDeliveryPanel: () => void;
	closeDeliveryPanel: () => void;
}

const DeliveryPanelContext = createContext<DeliveryPanelContextType | undefined>(undefined);

interface DeliveryPanelProviderProps {
	children: ReactNode;
}

export const DeliveryPanelProvider: FC<DeliveryPanelProviderProps> = ({ children }) => {
	const [isDeliveryPanelOpen, setIsDeliveryPanelOpen] = useState<boolean>(false);

	const openDeliveryPanel = () => setIsDeliveryPanelOpen(true);
	const closeDeliveryPanel = () => setIsDeliveryPanelOpen(false);

	return (
		<DeliveryPanelContext.Provider
			value={{ isDeliveryPanelOpen, openDeliveryPanel, closeDeliveryPanel }}
		>
			{children}
		</DeliveryPanelContext.Provider>
	);
};

export const useDeliveryLocationPanel = (): DeliveryPanelContextType => {
	const context = useContext(DeliveryPanelContext);
	if (!context) {
		throw new Error('useDeliveryLocationPanel must be used within a DeliveryPanelProvider');
	}
	return context;
};
